export const numberWithCommas = (x: number): string => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const numberWithCommasOpt = (
  x: number | undefined,
  fallback: string
): string => {
  return x !== undefined ? numberWithCommas(x) : fallback
}

export const formatNumberWithJapaneseStyle = (num: number) => {
  const fmt = new Intl.NumberFormat('ja-JP', {
    notation: 'compact',
  })
  return fmt.format(num)
}

export const formatNumberWithJapaneseStyleOpt = (num: number | undefined) => {
  if (num == null) return undefined
  const fmt = new Intl.NumberFormat('ja-JP', {
    notation: 'compact',
  })
  return fmt.format(num)
}
